module.exports = __webpack_public_path__ + "img/vu-tip-image.3e10d82.svg";